import { Paper, Stack, Typography } from '@mui/material';
import React from 'react';
import { CreateCustomerAddressSection } from '../../../CreateCustomerPage/create-customer-page-components/CreateCustomerCompanyDetails/create-customer-company-details-components/CreateCustomerAddressSection';
import { CreateCustomerContactsSection } from '../../../CreateCustomerPage/create-customer-page-components/CreateCustomerCompanyDetails/create-customer-company-details-components/CreateCustomerContactsSection';
import { CreateCustomerGeneralInformation } from '../../../CreateCustomerPage/create-customer-page-components/CreateCustomerCompanyDetails/create-customer-company-details-components/CreateCustomerGeneralInformation';

export const UpdateCustomerCompanyDetails: React.FC = () => {
  const mode = 'update';

  return (
    <Paper
      elevation={1}
      sx={{
        padding: '24px 32px',
        borderRadius: '10px',
        boxShadow: '0px 10px 24px rgba(0,0,0,0.03)',
        border: '1px solid rgba(13,27,39,0.1)',
        minHeight: '480px',
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'space-between',
        overflow: 'auto',
        minWidth: '880px',
      }}
    >
      <Stack spacing={3}>
        <Typography variant="h5" sx={{ fontWeight: 500, paddingTop: 1 }}>
          Company Details
        </Typography>

        <CreateCustomerGeneralInformation mode={mode} />
        <CreateCustomerAddressSection mode={mode} />
        <CreateCustomerContactsSection mode={mode} />
      </Stack>
    </Paper>
  );
};
